import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Lock } from 'lucide-react';
import useReveal from '../hooks/useReveal';
import useSeo from '../hooks/useSeo';
import CaseStudyCard from '../components/CaseStudyCard';
import CTA from '../components/CTA';
import { caseStudies } from '../mock/mock';

const filters = ['All'];

export default function CaseStudies() {
  const [active, setActive] = useState('All');
  useReveal(active);
  useSeo({ title: 'Case Studies | Interscope Ads Performance Results', description: 'Real, verified performance marketing case studies. See how Interscope scaled installs, subscriptions and revenue for global apps.' });

  const list = active === 'All'
    ? caseStudies
    : caseStudies.filter((c) => c.category.toLowerCase().includes(active.toLowerCase()));

  return (
    <main className="pt-32">
      <section className="relative max-w-7xl mx-auto px-5 md:px-8 pb-4 text-center">
        <span className="reveal inline-block mb-3 text-xs font-semibold tracking-[0.25em] uppercase text-[#2563eb]">Case Studies</span>
        <h1 className="reveal font-display text-4xl md:text-5xl lg:text-6xl font-bold text-slate-900 leading-[1.08] max-w-3xl mx-auto">
          Real brands, <span className="text-gradient">real results</span>
        </h1>
        <p className="reveal mt-6 text-slate-600 text-lg max-w-2xl mx-auto">
          Verified performance outcomes, measured on Adjust & AppsFlyer. No inflated numbers — just growth.
        </p>
      </section>

      <section className="relative max-w-7xl mx-auto px-5 md:px-8 pt-10">
        {filters.length > 1 && (
          <div className="flex flex-wrap justify-center gap-2.5 mb-12">
            {filters.map((f) => (
              <button key={f} onClick={() => setActive(f)} className={`px-5 py-2 rounded-full text-sm font-medium transition-colors ${active === f ? 'bg-gradient-to-r from-[#2563eb] to-[#1d4ed8] text-white' : 'glass text-slate-600 hover:text-blue-600 hover:border-[#2563eb]/40'}`}>
                {f}
              </button>
            ))}
          </div>
        )}

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {list.map((cs) => (<CaseStudyCard key={cs.slug} cs={cs} />))}

          {/* Confidential / more available card */}
          <div className="reveal rounded-2xl border border-dashed border-slate-200 bg-slate-50 p-8 flex flex-col justify-center items-center text-center">
            <span className="w-12 h-12 rounded-xl bg-[#2563eb]/12 grid place-items-center text-[#2563eb] mb-4"><Lock size={22} /></span>
            <h3 className="font-display text-lg font-semibold text-slate-900">More results under NDA</h3>
            <p className="text-sm text-slate-500 mt-2">Many of our engagements are confidential. Request a private walkthrough of results in your vertical.</p>
            <Link to="/contact" className="mt-5 inline-flex items-center gap-2 rounded-full glass px-6 py-3 text-sm font-semibold text-slate-900 hover:border-[#2563eb]/50 transition-colors">Request access</Link>
          </div>
        </div>
      </section>

      <CTA />
    </main>
  );
}
